import {
	DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
} from '../../entities';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { SmartsheetIcon } from './icon';
import { SmartsheetSearchResultIcon } from './search-result-icon';

export const smartsheetConfig: ThirdPartyConfig = {
	displayName: 'Smartsheet',
	id: 'smartsheet',
	resourceType: 'smartsheet-connector',
	icon: get3PLogo(SmartsheetIcon, 'Smartsheet', 'medium'),
	searchResultIcon: get3PLogo(SmartsheetSearchResultIcon, 'Smartsheet', 'large'),
	integrationAri: 'ari:cloud:platform::integration/smartsheet',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Document],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
